<template>
  <div>
    <br />
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <v-row>

          <!--            Production file-->
          <v-combobox 
              v-model="item.prodfile"
              :items="prodfileSelectItems"
              :error-messages="prodfileErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              :label="$t('prodfile.prodfile')"
              item-text="name"
              item-value="@id"
          />
          <v-btn height="50" @click="prodFileAdd"><v-icon>mdi-paperclip-plus</v-icon></v-btn>
        </v-row>
        <v-row>
          <v-text-field
            v-model.number="item.failedItems"
            :error-messages="failedItemsErrors"
            required
            :label="$t('order.failedItems')"
            @input="$v.item.failedItems.$touch()"
            @blur="$v.item.failedItems.$touch()"
        />
        </v-row>
      </v-col>
    </v-row>
    <v-expansion-panels v-model="boolExpansionPanel" v-if="newProdFile" width="500">
      <v-expansion-panel style="background-color:#272727">
        <v-expansion-panel-header>
          {{$t('prodfile.add')}}
        </v-expansion-panel-header>
        <v-expansion-panel-content>

          <ProdFileCreate :sub="true" @close="close"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>



</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
import has from "lodash/has";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import ProdFileCreate from "@/views/prodfile/Create.vue"


export default {
  name: 'PopupStatePrinted',
  mixins: [validationMixin],

  components: {
    ProdFileCreate,
  },

  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.prodfileGetSelectItems();

  },

  data() {
    return {
      prodfile: null,
      comment: null,
      newProdFile: 0,
      boolExpansionPanel: true,
      failedItems: null,
    }
  },

  computed: {
    isLoading() {
      return (
          this.isLoading_prodfile ||
          this.isLoading_material
      );
    },

    ...mapFields('prodfile', {
      prodfileSelectItems: 'selectItems',
      isLoading_prodfile : 'isLoading',
      createdProdFile: 'created'
    }),


    item() {
      return this.initialValues || this.values ;
    },

    prodfileErrors() {
      const errors = [];
      if (!this.$v.item.prodfile.$dirty) return errors;
      has(this.violations, 'prodfile') && errors.push(this.violations.prodfile);
      !this.$v.item.prodfile.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    failedItemsErrors() {
      const errors = [];
      if (!this.$v.item.failedItems.$dirty) return errors;
      has(this.violations, 'failedItems') && errors.push(this.violations.failedItems);
      !this.$v.item.failedItems.required && errors.push(this.$t('global.field_required'));
      return errors;
    },


    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      prodfileGetSelectItems: 'prodfile/fetchSelectItems',
    }),

    prodFileAdd() {
      this.newProdFile = !this.newProdFile;
    },
    closeExpansionPanel() {
      this.boolExpansionPanel = ! this.boolExpansionPanel
    },
    close() {
      this.closeExpansionPanel()
      //this.prodfileGetSelectItems()
    },

  },

  watch: {
    createdProdFile(data) {
      console.log(data);

      setTimeout(() => {
        this.prodfileGetSelectItems();
      }, 2000);
    },
    /*
    newProdFile() {
      if(this.newProdFile) {
        this.prodfileGetSelectItems()
      }
    }
      */
  },

  validations: {
    item: {
      prodfile: {
        required,
      },
      failedItems: {
        required,
      },
    }
  }
}
</script>

